import { useTranslation } from "react-i18next";
import ClientLogo from "./ClientLogo";
import {
  formatClientAddressDisplay,
  formatClientCreatedDate,
} from "./clientUtils";

const ClientRow = ({ data, onOpen }) => {
  const { t, i18n } = useTranslation();

  const handleRowClick = () => {
    onOpen?.(data);
  };

  const locale = i18n.language?.startsWith("fr") ? "fr-FR" : "en-GB";
  const createdDateFormatted = data?.createdAt
    ? formatClientCreatedDate(data.createdAt, locale)
    : null;
  const createdLabel =
    createdDateFormatted && createdDateFormatted !== "—"
      ? t("settingsClients.createdOn", { date: createdDateFormatted })
      : "—";
  const clientName = data?.name || "—";
  const clientAddress = formatClientAddressDisplay(data?.address);

  return (
    <div className="table-standard-row cursor-pointer" onClick={handleRowClick}>
      <div
        className="table-standard-row-cell min-w-0"
        data-label={t("settingsClients.columnOrigin")}
        title={`${clientName}${clientAddress !== "—" ? `\n${clientAddress}` : ""}`}
      >
        <div className="flex items-center gap-3 min-w-0 w-full">
          <ClientLogo client={data} size={36} />
          <div className="char-origin-cell-lines">
            <span className="char-origin-cell-truncate text-sm font-semibold text-[#222222]">
              {clientName}
            </span>
            <span className="char-origin-cell-truncate text-sm text-gray-500">
              {clientAddress}
            </span>
          </div>
        </div>
      </div>

      <div
        className="table-standard-row-cell text-sm text-[#5e5e5e] min-w-0"
        data-label={t("settingsClients.columnReference")}
        title={data.clientUniqueId || ""}
      >
        <span className="table-standard-row-cell-truncate">
          {data.clientUniqueId || "—"}
        </span>
      </div>

      <div
        className="table-standard-row-cell text-sm text-[#5e5e5e] min-w-0"
        data-label={t("settingsClients.columnCreatedAt")}
        title={createdLabel}
      >
        <span className="table-standard-row-cell-truncate">{createdLabel}</span>
      </div>
    </div>
  );
};

export default ClientRow;
